// extracted by mini-css-extract-plugin
export default {"readMore":"ReadMore_readMore__-U-Iw","description":"ReadMore_description__pXzRm"};